/* MEZUZAH GIFT (WO-790, Oct 20, 2026): the gift sync engine and the gift card preview, moved verbatim out of
   snippets/mezuzah-gift-sync.liquid and snippets/mezuzah-gift-preview.liquid, where they were printed inline on every
   page (and twice on product pages). Loaded once, deferred, from layout/theme.liquid. Both parts keep their own
   once-guards (window.__mezGiftSync, window.__mzGp) and read their values from the markup the snippets still render
   (the data-gift-note-config template and the data attributes), so nothing here depends on where it is printed.
   The sync part installs first (it did in the page too: the preview snippet renders gift-sync before its own script). */

  (function () {
    if (window.__mezGiftSync) return;
    window.__mezGiftSync = true;

    var NOTE_SEL = '[data-gift-note]';
    var TOGGLE_SEL = '[data-gift-toggle]';
    var OCC_SEL = '[data-gift-occasion]';
    function announce(el) { el.dispatchEvent(new Event('mezgift:sync', { bubbles: true })); }
    var FIELDS = [
      { sel: NOTE_SEL, key: 'Gift note', always: true },
      { sel: '[data-gift-to]', key: 'Gift to' },
      { sel: '[data-gift-from]', key: 'Gift from' }
    ];
    var KEYS = ['Gift', 'Gift note', 'Gift to', 'Gift from', 'Gift occasion'];
    var timers = {};
    var timerLive = {};          // WO-706: a typing pause that has been set and has not fired yet
    function setT(key, fn, ms) {
      clearTimeout(timers[key]);
      timerLive[key] = true;
      timers[key] = setTimeout(function () { timerLive[key] = false; fn(); notify(); }, ms);
    }
    function clearT(key) { clearTimeout(timers[key]); timerLive[key] = false; }
    function anyTimer() { for (var k in timerLive) if (timerLive[k]) return true; return false; }

    function fieldOf(el) {
      for (var i = 0; i < FIELDS.length; i++) {
        if (el.matches && el.matches(FIELDS[i].sel)) return FIELDS[i];
      }
      return null;
    }

    // WO-699 F6: every length and every cut counts characters (code points), so an emoji is 1 and never splits.
    function chars(s) { return Array.from(String(s || '')); }
    function cut(s, n) { var a = chars(s); return a.length > n ? a.slice(0, n).join('') : String(s || ''); }
    function msgLimit() {
      var limit = 0;
      document.querySelectorAll(NOTE_SEL).forEach(function (el) {
        var n = parseInt(el.getAttribute('data-limit') || el.maxLength, 10);
        if (n > limit) limit = n;
        var present = chars(el.value).length;
        if (present > limit) limit = present;
      });
      return limit > 0 ? limit : 300;
    }
    function valueOf(el, key) {
      var v = String(el.value || '').trim();
      return key === 'Gift note' ? cut(v, msgLimit()) : v;
    }

    // WO-711 add-on: the Gift note attribute of a gift with no message, one rule for every write, the read back and the order note block
    function noMsgText() { var c = document.querySelector('[data-gift-note-config]'); return c ? String(c.getAttribute('data-no-message') || '').trim() : ''; }
    function noteAttr(note, to, from) { var t = noMsgText(); return (!note && t) ? t : note; }   // WO-735: an empty message is always "No message", whatever To and From hold (staff can tell an empty message from a lost one)

    var confirmed = {};
    var latest = {};             // WO-712 P1-A: the latest values queued or in flight (what the cart will hold once every write has landed)
    var latestNote = null;       // and the latest note queued or in flight
    var known = {};              // WO-706: what the cart held at the last answer (and when the page was built), for rescue()
    var pending = null;
    var saveRequested = false;
    var saving = false;
    var immediateWrites = 0;     // WO-730 P1.1 (review): leaving writes (sendNow) in flight; they are part of the queue state (idle, flush, the skip rule) and their answer is verified
    var inflightAttrs = null;    // WO-730: the attributes of the write in flight (a leaving write that cancels it carries them on, they must not be lost)
    var inflightNote = null;
    var inflight = null;         // WO-715: the AbortController of the cart write now in flight, so a leaving page can cancel it before it overtakes a newer snapshot
    var suppress = 0;            // F10: no saves from the handlers while the gift is being cleared
    var failures = 0;            // F1: failed tries in a row
    var mismatchTries = 0;       // WO-726 P2-4: an answer that does not hold the values sent is tried once more, then it is a failure the customer sees
    var lastGiveUpMismatch = false;   // the last give up was such an answer (the cart form exit may still go on, it carries the same values)
    var onlineOnce = null;       // WO-726 P3-5: the online listener, so a new action can remove it
    var lastNoteRefresh = 0;
    var noteTyped = false;       // WO-726 F2: the order note box was typed in on this page
    var localEdits = {};         // WO-735 v7: only customer edits own a field; focus and a stale rendered value do not
    var cleanDisplay = {};
    var sessionEdits = {};
    var restoring = null;
    var editGeneration = 0;
    var repairRetired = false;
    function supersedeRepair() {
      editGeneration++; repairRetired = true; cancelRepair();
      cleanupActive = false;
      if (pending && KEYS.every(function (key) { return pending[key] === ''; })) { pending = null; if (!noteTyped) noteDirty = false; }
    }
    function edited(key) {
      if (suppress) return;
      localEdits[key] = true;
      sessionEdits[key] = true;
      if (key === 'Gift note') serverMessage = null;
      supersedeRepair();
    }
    function confirmedEdits(attrs, note) {
      var shown = typed();
      var current = Object.assign({}, shown);
      current.Gift = giftOn() ? 'yes' : 'no';
      current['Gift note'] = giftOn() ? noteAttr(current['Gift note'], current['Gift to'], current['Gift from']) : '';
      Object.keys(attrs).forEach(function (key) { if (norm(current[key]) === norm(attrs[key]) || (key === 'Gift' && !giftOn() && !norm(attrs[key]))) { delete localEdits[key]; cleanDisplay[key] = shown[key]; } });
      if (note !== null && customerNow() === customerOf(note)) { noteTyped = false; delete localEdits.note; }
      if (KEYS.every(function (key) { return attrs[key] === ''; })) cleanupActive = false;
    }
    // WO-779: announce a confirmed gift save for the Clarity events script. Called from BOTH confirmed paths (the queued write in flush() and the
    // leaving write in sendNow()) after the same checks: the cart answer held the values sent and that write is still the current one.
    // The events script counts gift_saved once per page; announcing never affects the save.
    function announceSaved(attrs) {
      if (!attrs || attrs.Gift !== 'yes') return;
      try { document.dispatchEvent(new CustomEvent('mezgift:saved')); } catch (e) { /* announcing never affects the save */ }
    }
    var skipWrap = false;        // the queue has already built its note from its guarded cart answer
    var guardCart = null;        // one guarded server snapshot is consumed by the next queue build
    var authoritativeCart = null;   // exits use the newest guarded answer already received, without waiting for another read
    var nativePreparing = 0;
    var writes = 0;              // WO-726 (LAW 51 round 2): counts the cart writes started, so an older /cart.js answer can be told from a newer cart
    var cartAnswers = 0;
    var cleanupAnswer = null;
    var cleanupActive = false;
    function currentAnswer(w, answer) { return writes === w && cartAnswers === answer; }
    var waitingForms = new WeakSet();   // WO-726 P3-7: a form or link whose exit is waiting for the save
    var retryTimer = null;
    var onlineWait = false;
    var gaveUp = false;
    var waiters = [];
    var BACKOFF = [1000, 2000, 4000, 8000];   // F1: 1 s, 2 s, 4 s, 8 s, then stop

    // ---- WO-669b: gift block inside the native order note (order.note) ----
    var MARK = '====================';
    var noteDirty = false;
    var noteTimer = null;
    var confirmedNote = null;
    var lastCount = null;

    function cfg() { return document.querySelector('[data-gift-note-config]'); }
    function noteEnabled() {
      var c = cfg();
      return !!(c && c.getAttribute('data-enabled') === '1');
    }
    function baseNote() {
      if (confirmedNote === null) { var c = cfg(); confirmedNote = c ? c.getAttribute('data-note') || '' : ''; }
      return confirmedNote;
    }
    function giftOn() {
      var t = document.querySelectorAll(TOGGLE_SEL);
      for (var i = 0; i < t.length; i++) if (t[i].checked) return true;
      return false;
    }
    // WO-711 finding 9: the two marker lines of the engine's block, or null. The block is the LAST pair of adjacent marker lines (a line that is only the 20 equal signs, spaces around it ignored)
    // whose first marker is followed by the heading line; with no heading set the note must hold exactly two marker lines. Any other note is the customer's own text and nothing in it is ever
    // removed (a customer's own lines of equal signs, before the block, no longer confuse it). snippets/cart-block-order-note.liquid applies the same rule.
    function findBlock(note) {
      note = String(note || '');
      var marks = [], start = 0, re = /\r?\n/g, m;
      while (true) {
        m = re.exec(note);
        var end = m ? m.index : note.length;
        if (note.slice(start, end).trim() === MARK) marks.push({ start: start, end: end });
        if (!m) break;
        start = m.index + m[0].length;
      }
      if (marks.length < 2) return null;
      var c = cfg(), heading = c ? String(c.getAttribute('data-heading') || '').trim() : '';
      if (!heading) return marks.length === 2 ? marks : null;
      for (var k = marks.length - 2; k >= 0; k--) {
        var first = note.slice(marks[k].end).replace(/^\r?\n/, '').split(/\r?\n/)[0];
        if (first.trim() === heading) return [marks[k], marks[k + 1]];
      }
      return null;
    }
    // Customer text of a stored note: everything outside the block, without the blank line we added.
    function customerOf(note) {
      var f = findBlock(note);
      if (!f) return note;
      return note.slice(0, f[0].start).replace(/\r?\n\r?\n$/, '') + note.slice(f[1].end);
    }
    function clean(v) { return String(v || '').replace(/={20}/g, '=').trim(); }
    var serverMessage = null;
    function blockMessage(note, attrs) {
      var block = findBlock(note);
      var c = cfg();
      if (!block || !c) return null;
      var lines = String(note).slice(block[0].end, block[1].start).replace(/^\r?\n|\r?\n$/g, '').split(/\r?\n/);
      var heading = String(c.getAttribute('data-heading') || '').trim();
      if (heading && lines[0].trim() === heading) lines.shift();
      var labels = [['data-to', 'Gift to'], ['data-from', 'Gift from'], ['data-occasion', 'Gift occasion']].map(function (pair) { return (String(c.getAttribute(pair[0]) || '') + ': ' + clean((attrs || {})[pair[1]])).trim(); });
      while (lines.length && labels.indexOf(lines[0].trim()) !== -1) lines.shift();
      if (!lines.some(function (line) { return line.trim() && line.trim() !== 'Gift note: ' + clean(noMsgText()); })) return null;
      return lines;
    }
    function giftBlock(values, preserved) {
      var c = cfg();
      var get = function (a) { return c.getAttribute(a) || ''; };
      var first = function (sel) { var el = document.querySelector(sel); return el ? clean(el.value) : ''; };
      var tv = values || typed();   // WO-712b (3): To, From and the occasion keep their latest known value when their inputs are not on the page
      var message = cut(values ? clean(norm(values['Gift note']) === norm(noMsgText()) ? '' : values['Gift note']) : first(NOTE_SEL), msgLimit());   // F6: the same limit as the message field
      var lines = [MARK];
      if (get('data-heading')) lines.push(get('data-heading'));
      if (clean(tv['Gift to'])) lines.push(get('data-to') + ': ' + clean(tv['Gift to']));
      if (clean(tv['Gift from'])) lines.push(get('data-from') + ': ' + clean(tv['Gift from']));
      if (clean(tv['Gift occasion'])) lines.push(get('data-occasion') + ': ' + clean(tv['Gift occasion']));
      var keep = preserved || (!values && !localEdits['Gift note'] && serverMessage);
      if (keep) {
        lines = lines.concat(keep);
      } else if (message) {
        if (get('data-msg')) lines.push(get('data-msg') + ':');
        lines.push(message);
      } else if (noteAttr('', clean(tv['Gift to']), clean(tv['Gift from']))) {   // WO-726 P3-1: the same values the attribute is built from
        lines.push('Gift note: ' + clean(noMsgText()));   // WO-711 add-on: a gift with no card message says so
      }
      lines.push(MARK);
      return lines.join('\n');
    }
    function withBlock(customer, values, preserved) {
      return customer + (customer === '' ? '' : '\n\n') + giftBlock(values, preserved);
    }
    function noteSnapshot(cart) {
      return !!(cart && typeof cart === 'object' && cart.attributes && typeof cart.attributes === 'object' && !Array.isArray(cart.attributes) && Object.prototype.hasOwnProperty.call(cart, 'note') && (cart.note === null || typeof cart.note === 'string'));
    }
    function rememberCart(cart) {
      if (noteSnapshot(cart)) authoritativeCart = { attributes: Object.assign({}, cart.attributes), note: cart.note, item_count: cart.item_count };
    }
    function composeCartNote(cart, owned, customer) {
      if (!noteSnapshot(cart)) throw new Error('Cart answer unreadable');
      var note = String(cart.note || '');
      var server = cart.attributes;
      var attrs = Object.assign({}, server, owned || {});
      var text = customer === null ? customerOf(note) : String(customer);
      var preserved = !Object.prototype.hasOwnProperty.call(owned || {}, 'Gift note') && (!norm(attrs['Gift note']) || norm(attrs['Gift note']) === norm(noMsgText())) ? blockMessage(note, server) : null;
      return noteEnabled() && attrs.Gift === 'yes' ? withBlock(text, attrs, preserved) : text;
    }
    // F5: there is one order note box per page; its text is the customer's own.
    function customerNow() {
      var box = document.querySelector('textarea[name="note"]');
      return box ? box.value : customerOf(baseNote());
    }
    // The note the cart should hold right now.
    function wantedNote() {
      var customer = customerNow();
      return noteEnabled() && giftOn() ? withBlock(customer) : customer;
    }
    function scheduleNote() {
      if (!noteEnabled()) return;
      noteDirty = true;
    }

    function showSaveError(show) {
      document.querySelectorAll('[data-gift-save-error]').forEach(function (el) {
        el.hidden = !show;
      });
    }

    // ---- WO-699 F2 and F3: other scripts (the card, the checkout wait) ask this routine when it is idle ----
    function idle() { return !saving && !immediateWrites && !nativePreparing && !pending && !saveRequested && !noteDirty && !retryTimer && !onlineWait && !anyTimer(); }
    function notify() {
      if (!idle() && !gaveUp) return;
      var w = waiters.splice(0);
      w.forEach(function (fn) { fn(); });
    }
    // Resolves { ok } when every queued write has landed (ok), or the routine gave up, or maxMs passed.
    function settle(maxMs) {
      return new Promise(function (resolve) {
        if (idle()) { resolve({ ok: !gaveUp }); return; }
        var done = false;
        var fn = function () { if (done) return; done = true; clearTimeout(t); resolve({ ok: idle() && !gaveUp }); };
        var t = setTimeout(function () { var i = waiters.indexOf(fn); if (i >= 0) waiters.splice(i, 1); fn(); }, maxMs);
        waiters.push(fn);
      });
    }

    function waitOnline() {
      if (onlineWait) return;
      onlineWait = true;
      var once = function () {
        window.removeEventListener('online', once);
        onlineOnce = null;
        onlineWait = false;
        failures = BACKOFF.length;   // F1: back online means one try; a failure now gives up
        flush();
      };
      onlineOnce = once;
      window.addEventListener('online', once);
    }

    // WO-711: text compared the way Shopify may have stored it (line ends, trailing spaces)
    function norm(s) { return String(s == null ? '' : s).replace(/\r\n/g, '\n').replace(/[ \t]+$/gm, '').trim(); }
    function answerHolds(cart, attrs, note) {
      if (!cart || typeof cart !== 'object') return false;
      var a = cart.attributes || {};
      var keys = Object.keys(attrs);
      for (var i = 0; i < keys.length; i++) if (norm(a[keys[i]]) !== norm(attrs[keys[i]])) return false;
      if (note !== null && norm(cart.note) !== norm(note)) return false;
      return true;
    }

    function flush() {
      var fresh = guardCart;
      guardCart = null;
      if (saving || immediateWrites || nativePreparing || retryTimer || onlineWait) return;
      if (!pending && !noteDirty && !saveRequested) { notify(); return; }
      if (repairValue !== null) { if (!repairChecked) { checkRepairThenFlush(); return; } repairChecked = false; }   // WO-735 v6b: the load repair is checked before every send attempt
      var attrs = pending || {};
      var forceBody = saveRequested;
      saveRequested = false;
      var rebuildNote = noteDirty;
      var repairBody = repairPending;
      var cleanupBody = KEYS.every(function (key) { return attrs[key] === ''; });
      var repairGeneration = editGeneration;
      repairPending = false;
      pending = null;
      var note = null;
      noteDirty = false;
      if (!Object.keys(attrs).length && !rebuildNote && !forceBody) { notify(); return; }
      // Every note body is built from a current server cart and the fields this request owns.
      if (forceBody || cleanupBody || rebuildNote) {
        if (!fresh || !currentAnswer(fresh.w, fresh.answer) || editGeneration !== fresh.generation) {
          var heldAttrs = attrs;
          var w0 = writes;
          var answer0 = cartAnswers;
          var generation0 = editGeneration;
          saving = true;
          nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) { return cart; }, function () { return null; })
            .then(function (cart) {
              saving = false;
              if (!currentAnswer(w0, answer0) || editGeneration !== generation0) {
                var intent = Object.assign({}, heldAttrs, pending || {});
                KEYS.forEach(function (key) { if (localEdits[key]) intent[key] = true; });
                var owned = ownedAttributes(intent);
                pending = Object.keys(owned).length ? owned : null;
                saveRequested = saveRequested || forceBody;
                if (!repairBody && (!cleanupBody || Object.keys(owned).length || noteTyped)) noteDirty = noteDirty || rebuildNote;
                if (repairBody) cancelRepair();
                flush();
                return;
              }
              if (!noteSnapshot(cart)) cart = null;
              if (repairBody && (repairRetired || editGeneration !== repairGeneration || repairValue === null)) heldAttrs = {};
              if (cleanupBody && cart && cart.item_count > 0) { heldAttrs = {}; if (!noteTyped) rebuildNote = false; }
              pending = Object.keys(heldAttrs).length ? Object.assign({}, heldAttrs, pending || {}) : pending;
              saveRequested = saveRequested || forceBody;
              if ((!cleanupBody || rebuildNote) && (!repairBody || (!repairRetired && editGeneration === repairGeneration && repairValue !== null))) { noteDirty = true; repairPending = repairBody; }
              if (repairValue !== null) { if (cart && writes === w0 && cartAnswers === answer0 && repairStillValid(cart)) { if (typeof cart.note === 'string') { confirmedNote = cart.note; latestNote = null; } repairChecked = true; } else cancelRepair(); }   // WO-735 v6b: the repair is checked against this fresh read too (it counts as the check of the next send)
              if (cart) adoptServerValues(cart);
              guardCart = cart ? { cart: cart, w: writes, answer: cartAnswers, generation: editGeneration } : null;
              if (!cart && !repairBody) { gaveUp = true; if (Object.keys(heldAttrs).length || forceBody) showSaveError(true); notify(); return; }
              flush();
            });
          return;
        }
        var wanted = composeCartNote(fresh.cart, attrs, noteTyped ? customerNow() : null);
        if (wanted !== String(fresh.cart.note || '')) note = wanted;
        else if (noteTyped) confirmedEdits({}, wanted);
      }
      if (!Object.keys(attrs).length && note === null && !forceBody) { notify(); return; }
      if (note !== null) latestNote = note;
      saving = true;

      var body = {};
      if (Object.keys(attrs).length) body.attributes = attrs;
      if (note !== null) body.note = note;
      // F3: keepalive, so a save that is still in flight when the page changes is not cancelled
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      if (ctl && repairBody) ctl.repair = true;
      inflight = ctl;
      inflightAttrs = attrs;
      inflightNote = note;
      var init = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true };
      if (ctl) init.signal = ctl.signal;
      writes++;
      skipWrap = true;
      var reqP = fetch('/cart/update.js', init);
      var writeVersion = writes;
      var answerVersion = cartAnswers;
      if (cleanupBody) cleanupAnswer = answerVersion;
      var accepted = false;
      skipWrap = false;
      reqP
        .then(function (response) {
          if (!response.ok) {
            var err = new Error('Cart update failed: ' + response.status);
            err.status = response.status;
            err.retryAfter = response.headers && response.headers.get ? response.headers.get('Retry-After') : null;
            throw err;
          }
          return response.clone().json().then(function (cart) {
            if ((ctl && ctl.cancelled) || !currentAnswer(writeVersion, answerVersion)) return;
            // WO-711 / LAW 55: saved means confirmed: the answer must hold the values just sent (the attributes, and the note when it was sent)
            if (!answerHolds(cart, attrs, note)) { var bad = new Error('Cart answer does not hold the values sent'); bad.status = 409; bad.mismatch = true; throw bad; }
            accepted = true;
            noteCart(cart);
          }, function () { throw new Error('Cart answer unreadable'); });
        })
        .then(function () {
          if ((ctl && ctl.cancelled) || !accepted || !currentAnswer(writeVersion, answerVersion)) return;
          Object.keys(attrs).forEach(function (key) { confirmed[key] = attrs[key]; known[key] = attrs[key]; });
          if (note !== null) confirmedNote = note;
          confirmedEdits(attrs, note);
          if (repairValue !== null && attrs['Gift note'] === repairValue) { repairValue = null; repairChecked = false; }   // WO-735 v6b: the repair is done
          announceSaved(attrs);   // WO-779: the answer held what was sent and this write is the current one
          failures = 0;
          mismatchTries = 0;
          gaveUp = false;
          lastGiveUpMismatch = false;
          showSaveError(false);
        })
        .catch(function (err) {
          // WO-715: a write cancelled on purpose (the page is leaving, sendNow sent the newer snapshot) is not a failure and its values are not queued again
          if (ctl && ctl.cancelled) return;
          if (!currentAnswer(writeVersion, answerVersion)) {
            var owned = ownedAttributes(attrs);
            if (Object.keys(owned).length) { pending = Object.assign({}, owned, pending || {}); noteDirty = true; }
            return;
          }
          // keep the values queued, then F1: back-off 1, 2, 4, 8 s and stop; no retry on a 4xx except 429; offline waits for the online event
          pending = pending || {};
          saveRequested = saveRequested || forceBody;
          if (repairBody && !repairRetired && editGeneration === repairGeneration && repairValue !== null) repairPending = true;
          Object.keys(attrs).forEach(function (key) {
            if (!(key in pending)) pending[key] = attrs[key];
          });
          if (note !== null) noteDirty = true;
          failures++;
          var status = err && err.status;
          // WO-726 P2-4: an answer that does not hold the values sent (the server stored them differently) is tried ONCE more, a second one is a failure the customer sees
          var mismatch = !!(err && err.mismatch);
          var retryable = !status || status === 429 || status >= 500 || (mismatch && mismatchTries < 1);
          if (mismatch && retryable) mismatchTries++;
          if (!retryable || failures > BACKOFF.length) {
            gaveUp = true;
            lastGiveUpMismatch = mismatch;
            // WO-726 P2-2: the gift error belongs to a write that carries gift attributes, never to a note-only body
            if (Object.keys(attrs).length) showSaveError(true);
            return;
          }
          if (!status && navigator.onLine === false) { waitOnline(); return; }
          var wait = BACKOFF[failures - 1];
          if (status === 429 && err.retryAfter) {
            var s = parseFloat(err.retryAfter);
            if (s > 0) wait = Math.min(s * 1000, 60000);
          }
          retryTimer = setTimeout(function () { retryTimer = null; flush(); }, wait);
        })
        .then(function () {
          saving = false;
          if (inflight === ctl) { inflight = null; inflightAttrs = null; inflightNote = null; }
          if (!gaveUp && !retryTimer && !onlineWait && (pending || noteDirty || saveRequested)) { flush(); return; }
          notify();
        });
    }

    // force: a Save click always sends every value (F8), never skipped as "same as last confirmed"
    function saveCartAttributes(attrs, force) {
      pending = pending || {};
      var any = false;
      Object.keys(attrs).forEach(function (key) {
        // WO-709 A3 and WO-712 P1-A: idle: skip a value the cart already holds; with a write in flight skip ONLY a value that is the latest one queued or in flight (an older write may still change the cart,
        // so a value equal to the last confirmed one is NOT skipped then)
        var same = (saving || immediateWrites) ? (latest[key] === attrs[key]) : (confirmed[key] === attrs[key]);
        if (!force && same && !(key in pending)) return;
        pending[key] = attrs[key];
        latest[key] = attrs[key];
        any = true;
      });
      if (!any) { if (!Object.keys(pending).length) pending = null; return; }
      // a new action starts a fresh set of tries
      // WO-726 P3-5 and P1-1: the online wait ends (and its listener goes, so it cannot fire later and set failures = 4) ONLY when the network is back; an action taken while still offline keeps both
      if (onlineWait && navigator.onLine !== false) {
        onlineWait = false;
        if (onlineOnce) { window.removeEventListener('online', onlineOnce); onlineOnce = null; }
      }
      failures = 0;
      mismatchTries = 0;
      gaveUp = false;
      lastGiveUpMismatch = false;
      if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
      scheduleNote();
      flush();
    }

    function mirrorNote(from, sel) {
      document.querySelectorAll(sel).forEach(function (f) {
        if (f !== from && f.value !== from.value) { f.value = from.value; announce(f); }
      });
    }
    document.addEventListener('click', function (e) {
      var button = e.target && typeof e.target.closest === 'function' ? e.target.closest('[data-gp-act]') : null;
      var root = button && button.closest('[data-mz-gp]');
      if (!root) return;
      var action = button.getAttribute('data-gp-act');
      if (action === 'open' || action === 'edit') sessionEdits = {};
      if (action === 'cancel') {
        restoring = { root: root, owned: Object.assign({}, sessionEdits), values: typed() };
        setTimeout(function () { restoring = null; sessionEdits = {}; }, 0);
      }
      if (action === 'remove-yes') sessionEdits = {};
    }, true);
    function restoredField(event, key) {
      var root = event.target && typeof event.target.closest === 'function' ? event.target.closest('[data-mz-gp]') : null;
      if (!root || event.isTrusted) return null;
      if (restoring && restoring.root === root && !restoring.owned[key]) return restoring.values;
      if (freshCards.has(root) && !localEdits[key]) return freshCards.get(root);
      return null;
    }

    // WO-699 F3: on /cart the cart form carries the Gift flag and the occasion too, through hidden inputs that are only
    // enabled (and so only sent) while they have a value. (Named radios would join the cards of the drawer and the page
    // into one radio group.)
    function syncHidden() {
      var on = giftOn();
      var occ = document.querySelector(OCC_SEL + ':checked');
      // WO-709 A1 and LAW 38: never rely on disabled (theme.js re-enables every cart input); the value says it: yes or no, the occasion or empty
      document.querySelectorAll('[data-gift-hidden="flag"]').forEach(function (h) { h.disabled = false; h.value = on ? 'yes' : 'no'; });
      document.querySelectorAll('[data-gift-hidden="occ"]').forEach(function (h) {
        h.disabled = false;
        h.value = on && occ ? String(occ.value || '') : '';
      });
      // WO-711 add-on: the cart page form carries the Gift note too, from a hidden input, because the visible message box is empty for a gift with no message
      document.querySelectorAll('[data-gift-hidden="note"]').forEach(function (h) {
        var t = typed();
        h.disabled = false;
        h.value = on ? noteAttr(t['Gift note'], t['Gift to'], t['Gift from']) : '';
      });
    }

    // WO-669: the occasion is one of several radio pills; the chosen value (blank when un-chosen) is the attribute.
    function onOccasion(t) {
      edited('Gift occasion');
      var val = t.checked ? t.value : '';
      document.querySelectorAll(OCC_SEL).forEach(function (r) {
        var want = val !== '' && r.value === val;
        if (r.checked !== want) { r.checked = want; announce(r); }
      });
      syncHidden();
      if (!giftOn() || suppress) return;   // F4: a gift that is not saved yet writes nothing
      saveCartAttributes(fieldAttrs('Gift occasion', val));   // WO-735 v5 (forensics on order 140687): the occasion write carries the Gift note too (the typed message, or the No message text), like To and From
    }

    function mirrorToggle(from) {
      document.querySelectorAll(TOGGLE_SEL).forEach(function (f) {
        if (f !== from && f.checked !== from.checked) f.checked = from.checked;
      });
      document.querySelectorAll('[data-gift-card]').forEach(function (card) {
        card.classList.toggle('is-open', from.checked);
      });
      syncHidden();
    }

    // the attribute of one field, plus the Gift note attribute worked out from all three (No message when all are empty, the typed message otherwise)
    function fieldAttrs(key, v) {
      var t = typed(), a = {};
      a[key] = v;
      var note = key === 'Gift note' ? v : t['Gift note'], to = key === 'Gift to' ? v : t['Gift to'], from = key === 'Gift from' ? v : t['Gift from'];
      var value = noteAttr(note, to, from);
      if (key !== 'Gift note' && norm(note) !== norm(cleanDisplay['Gift note'])) edited('Gift note');
      if (key === 'Gift note' || localEdits['Gift note'] || (!note && (!norm(known['Gift note']) || norm(known['Gift note']) === norm(noMsgText())))) {
        a['Gift note'] = value;
      }
      return a;
    }

    document.addEventListener('input', function (e) {
      var field = e.target.matches ? fieldOf(e.target) : null;
      if (!field) return;
      var restored = restoredField(e, field.key);
      if (restored) { e.target.value = restored[field.key] || ''; cleanDisplay[field.key] = e.target.value; mirrorNote(e.target, field.sel); announce(e.target); return; }
      edited(field.key);
      // F6: the message is held to its limit by characters, not by UTF-16 units
      if (field.key === 'Gift note' && e.target.hasAttribute('data-limit')) {
        var lim = parseInt(e.target.getAttribute('data-limit'), 10);
        if (lim > 0 && chars(e.target.value).length > lim) e.target.value = cut(e.target.value, lim);
      }
      mirrorNote(e.target, field.sel);
      if (!giftOn() || suppress) return;   // F4 and WO-706: with the gift off nothing is written here; the card turns the gift on when words appear
      syncHidden();
      var v = valueOf(e.target, field.key);
      setT(field.key, function () { saveCartAttributes(fieldAttrs(field.key, v)); }, 500);
    });

    document.addEventListener('focusout', function (e) {
      var field = e.target.matches ? fieldOf(e.target) : null;
      if (!field) return;
      if (!giftOn() || suppress || !localEdits[field.key]) return;
      clearT(field.key);
      saveCartAttributes(fieldAttrs(field.key, valueOf(e.target, field.key)));
    });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches(OCC_SEL)) {
        var restored = restoredField(e, 'Gift occasion');
        if (restored) { document.querySelectorAll(OCC_SEL).forEach(function (radio) { radio.checked = !!restored['Gift occasion'] && radio.value === restored['Gift occasion']; announce(radio); }); syncHidden(); return; }
        onOccasion(t); return;
      }
      if (!t.matches || !t.matches(TOGGLE_SEL)) return;

      mirrorToggle(t);
      if (suppress) return;
      if (!window.__mezGiftQuiet) edited('Gift');

      if (t.checked) {
        if (window.__mezGiftQuiet) return;   // WO-709 A2: the card sends one full snapshot (saveNow), never a flag alone
        saveCartAttributes({ Gift: 'yes' });
        return;
      }

      // WO-730 P2.1 (review): all five attributes are cleared, also the ones whose inputs the page hides by settings (a later empty gift must not bring Alice, Bob and Wedding back)
      var cleared = { Gift: 'no', 'Gift note': '', 'Gift to': '', 'Gift from': '', 'Gift occasion': '' };
      KEYS.forEach(function (key) { localEdits[key] = true; });
      FIELDS.forEach(function (field) {
        var els = document.querySelectorAll(field.sel);
        if (!els.length && !field.always) return;
        clearT(field.key);
        els.forEach(function (f) { f.value = ''; announce(f); });
        cleared[field.key] = '';
      });
      var occs = document.querySelectorAll(OCC_SEL);
      if (occs.length) {
        occs.forEach(function (r) { if (r.checked) { r.checked = false; announce(r); } });
        cleared['Gift occasion'] = '';
      }
      syncHidden();
      saveCartAttributes(cleared);
    });

    // WO-669b and WO-711 finding 4: the theme's own order note box is saved as it is typed, with the gift on (customer text + block) or off (customer text), because Shop Pay, Apple Pay and the other wallets
    // never submit the cart form and the theme saves the note only on a submit.
    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('textarea[name="note"]')) return;
      edited('note');
      noteTyped = true;
      setT('order note', function () { noteDirty = true; flush(); }, 500);
    });

    // ---- WO-699 F2 and F8: the card's Save writes the Gift flag and every field, always, then reads the cart back ----
    function readBack(expected) {
      var w = writes;
      var answer = cartAnswers;
      var generation = editGeneration;
      return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('read back ' + r.status); return r.json(); })
        .then(function (cart) {
          if (!currentAnswer(w, answer) || editGeneration !== generation) return false;
          noteCart(cart);
          if (!currentAnswer(w, answer)) return false;
          adoptServerValues(cart);
          var a = (cart && cart.attributes) || {};
          var norm = function (s) { return String(s || '').replace(/\r\n/g, '\n').replace(/[ \t]+$/gm, '').trim(); };
          var holds = Object.keys(expected).every(function (k) { return norm(a[k]) === norm(expected[k]); });
          if (holds) { confirmedEdits(expected, null); adoptServerValues(cart); }
          return holds;
        });
    }
    // WO-712b (3): the values a Save or a check expects: a field with no input anywhere on the page is not empty, it keeps its latest known value
    function effExpected(values) {
      var has = function (sel) { return !!document.querySelector(sel); };
      var to = has('[data-gift-to]') ? String(values.to || '').trim() : fallbackOf('Gift to');
      var from = has('[data-gift-from]') ? String(values.from || '').trim() : fallbackOf('Gift from');
      var occ = has(OCC_SEL) ? String(values.occ || '').trim() : fallbackOf('Gift occasion');
      return { 'Gift': 'yes', 'Gift note': noteAttr(cut(String(values.note || '').trim(), msgLimit()), to, from), 'Gift to': to, 'Gift from': from, 'Gift occasion': occ };
    }
    // values: { to, from, note, occ } as the card shows them. Resolves true only when the cart holds exactly that.
    function saveNow(values) {
      supersedeRepair();
      var generation = editGeneration;
      localEdits.Gift = true;
      var full = effExpected(values);
      var create = known.Gift !== 'yes';
      if (create) Object.keys(full).forEach(function (key) { localEdits[key] = true; });
      var expected = create ? full : ownedAttributes(full);
      Object.keys(timers).forEach(function (k) { clearT(k); });
      saveRequested = true;
      saveCartAttributes(expected, true);
      scheduleNote();
      flush();
      return settle(20000).then(function (res) {
        if (!res.ok) return false;
        return readBack(expected).then(function (ok) {
          if (ok && editGeneration === generation) {
            var current = typed();
            [['to', 'Gift to'], ['from', 'Gift from'], ['note', 'Gift note'], ['occ', 'Gift occasion']].forEach(function (pair) { if (!Object.prototype.hasOwnProperty.call(expected, pair[1])) values[pair[0]] = current[pair[1]]; });
          }
          return ok;
        }).catch(function () { return false; });
      });
    }

    // ---- WO-699 F10: an emptied cart loses its gift ----
    function noteCart(cart) {
      try {
        rememberCart(cart);
        if (!cart || typeof cart.item_count !== 'number') return;
        var before = lastCount;
        lastCount = cart.item_count;
        if (before !== null && before > 0 && cart.item_count === 0) clearGiftOfEmptyCart(cart);
      } catch (err) { /* never break the save chain */ }
    }
    function clearGiftOfEmptyCart(cart) {
      var a = cart.attributes || {};
      var note = cart.note || '';
      var has = KEYS.some(function (k) { return a[k]; }) || !!findBlock(note);
      if (!has) return;
      suppress++;
      try {
        Object.keys(timers).forEach(function (k) { clearT(k); });
        document.querySelectorAll(TOGGLE_SEL).forEach(function (t) { if (t.checked) { t.checked = false; t.dispatchEvent(new Event('change', { bubbles: true })); } });
        FIELDS.forEach(function (field) { document.querySelectorAll(field.sel).forEach(function (f) { if (f.value !== '') { f.value = ''; announce(f); } }); });
        document.querySelectorAll(OCC_SEL).forEach(function (r) { if (r.checked) { r.checked = false; announce(r); } });
        syncHidden();
      } finally { suppress--; }
      // WO-711 finding 5: the cleanup is one body in the SAME queue (serialized behind any write in flight, retried and verified like every other write); it replaces anything still pending,
      // and the confirmed state is reset from its answer, not before it. The note is the customer's own text (the gift is off, so wantedNote() holds no block).
      var blanks = {};
      KEYS.forEach(function (k) { blanks[k] = ''; });
      pending = blanks;
      cleanupAnswer = cartAnswers;
      cleanupActive = true;
      confirmed = {};
      known = {};
      latest = {};
      latestNote = null;
      confirmedNote = note;
      noteDirty = true;
      // WO-726 P3-4: a fresh set of tries (earlier failures must not make the cleanup give up on its first)
      failures = 0; mismatchTries = 0; gaveUp = false; lastGiveUpMismatch = false;
      if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
      if (onlineWait && navigator.onLine !== false) {
        onlineWait = false;
        if (onlineOnce) { window.removeEventListener('online', onlineOnce); onlineOnce = null; }
      }
      flush();
      try { sessionStorage.removeItem('mezGift:' + (document.cookie.match(/(?:^|; )cart=([^;]+)/) || [0, 'anon'])[1]); } catch (err) { /* no storage */ }
      document.dispatchEvent(new Event('mezgift:cleared'));
    }

    // ---- WO-699 F3: nothing is lost on the way out (Add to cart, Checkout) ----
    var go = new WeakSet();
    // WO-711 findings 1 and 21 / LAW 55: the exit goes on ONLY when every gift save is confirmed. A failed save, a rejected one, an answer that does not hold the values, or a wait that runs out
    // shows the save error and keeps the customer on the page; the next press tries again.
    // WO-726: viaForm is true for the cart form's own exit (Check Out); done() runs when the wait is over, whatever the outcome
    function waitThen(run, viaForm, done) {
      if (gaveUp) { gaveUp = false; failures = 0; mismatchTries = 0; lastGiveUpMismatch = false; flush(); }   // the customer pressed again: one more try
      var auto = window.mezGiftAutoSave ? window.mezGiftAutoSave() : null;   // the card's "Add to cart counts as Save"
      if (!auto && idle()) return false;
      // The native form can carry a real order-note edit after its own fresh merge, even while its API save is held or failed.
      if (!auto && viaForm && noteTyped && !KEYS.some(function (key) { return !!localEdits[key]; })) return false;
      // WO-726 P2-2: with the gift OFF the queued write is the order note (or the Gift = no clear, which the cart form carries as well): it never blocks an exit (the cart form posts the note and the gift fields itself, wallets are covered by rescue())
      if (!auto && !giftOn()) return false;
      Promise.resolve(auto)
        .then(function (results) {
          var bad = Array.isArray(results) && results.some(function (ok) { return ok === false; });
          return settle(3000).then(function (res) { return { ok: !bad && res.ok, mismatch: !res.ok && lastGiveUpMismatch }; });
        }, function () { return { ok: false }; })
        .then(function (r) {
          if (done) done();
          if (r.ok) { run(); return; }
          showSaveError(true);
          // WO-726 P2-4: the server stored the values differently (a persistent mismatch): the error shows and the cart form exit still goes on, the form carries the same values itself
          if (r.mismatch && viaForm) run();
        })
        .catch(function () { if (done) done(); showSaveError(true); });   // WO-726: nothing may leave the form waiting for good
      return true;
    }
    var nativeForms = new WeakSet();
    var nativePlans = new WeakMap();
    function nativeNoteIntent() { return noteTyped || !!localEdits['Gift note'] || !!localEdits.Gift; }
    function nativePlanCurrent(plan) { return plan && currentAnswer(plan.w, plan.answer) && plan.generation === editGeneration; }
    function prepareNativeForm(f) { if (f && f.id === 'cartForm') { nativeForms.add(f); setTimeout(function () { nativeForms.delete(f); nativePlans.delete(f); }, 0); } }
    function resumeNativeForm(f, submitter) {
      if (f.requestSubmit) { go.add(f); try { f.requestSubmit(submitter || undefined); return; } catch (err) { go.delete(f); } }
      if (prepareNativeNote(f, function () { prepareNativeForm(f); f.submit(); })) return;
      prepareNativeForm(f); f.submit();
    }
    function prepareNativeNote(f, run) {
      if (!f || f.id !== 'cartForm' || !nativeNoteIntent() || nativePlanCurrent(nativePlans.get(f))) return false;
      var intent = {};
      KEYS.forEach(function (key) { if (localEdits[key]) intent[key] = true; });
      var owned = ownedAttributes(intent);
      var customer = noteTyped ? customerNow() : null;
      var generation = editGeneration;
      if (inflight) {
        inflight.cancelled = true; try { inflight.abort(); } catch (err) { /* already settled */ }
        inflight = null; inflightAttrs = null; inflightNote = null;
      }
      Object.keys(timers).forEach(function (key) { clearT(key); });
      if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
      pending = null; noteDirty = false; saveRequested = false; guardCart = null; latestNote = null;
      var w = ++writes;
      var answer = ++cartAnswers;
      nativePreparing++;
      waitingForms.add(f);
      var sent = false;
      nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Cart answer unreadable'); return response.json(); })
        .then(function (cart) {
          if (!currentAnswer(w, answer) || generation !== editGeneration || !noteSnapshot(cart)) throw new Error('Cart answer unreadable');
          rememberCart(cart);
          nativePlans.set(f, { w: w, answer: answer, generation: generation, owned: owned, note: composeCartNote(cart, owned, customer) });
          waitingForms.delete(f);
          sent = true;
          run();
        })
        .catch(function () {
          if (nativePlanCurrent(nativePlans.get(f))) return;
          var current = Object.assign({}, pending || {});
          KEYS.forEach(function (key) { if (localEdits[key]) current[key] = true; });
          var retry = ownedAttributes(current);
          pending = Object.keys(retry).length ? retry : null;
          noteDirty = noteTyped || Object.keys(retry).length > 0;
          if (currentAnswer(w, answer) && generation === editGeneration) {
            nativePlans.delete(f);
            gaveUp = true;
            if (Object.keys(retry).length) showSaveError(true);
          }
        })
        .then(function () {
          waitingForms.delete(f);
          nativePreparing--;
          if (!sent && !gaveUp) flush();
          notify();
        });
      return true;
    }
    document.addEventListener('submit', function (e) {
      syncHidden();   // WO-709 A1: the hidden flag and occasion say what the cards say, right before the form is read
      var f = e.target;
      if (f && waitingForms.has(f) && !go.has(f)) { e.preventDefault(); e.stopImmediatePropagation(); return; }   // WO-726 P3-7: a second tap while the exit waits for the save
      if (f && go.has(f)) { go.delete(f); } else if (f && f.action) {
        var isAdd = f.action.indexOf('/cart/add') !== -1;
        var isCart = f.id === 'cartForm' || (e.submitter && e.submitter.name === 'checkout') || !!(f.querySelector && f.querySelector('[name="checkout"]'));
        if (isAdd || isCart) {
          var submitter = e.submitter;
          var blocked = waitThen(function () {
            resumeNativeForm(f, submitter);
          }, isCart, function () { waitingForms.delete(f); });
          if (blocked) { waitingForms.add(f); e.preventDefault(); e.stopImmediatePropagation(); return; }
        }
      }
      if (prepareNativeNote(f, function () { resumeNativeForm(f, e.submitter); })) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      prepareNativeForm(f);
    }, true);
    document.addEventListener('formdata', function (e) {
      if (!nativeForms.has(e.target)) return;
      var plan = nativePlans.get(e.target);
      var prepared = nativePlanCurrent(plan);
      var names = { note: 'note' };
      KEYS.forEach(function (key) { names['attributes[' + key + ']'] = key; });
      Array.prototype.forEach.call(e.target.elements, function (field) { var key = names[field.name]; if (key && (key === 'note' || prepared || !localEdits[key])) e.formData.delete(field.name); });
      if (prepared) {
        Object.keys(plan.owned).forEach(function (key) { e.formData.set('attributes[' + key + ']', plan.owned[key]); });
        e.formData.set('note', plan.note);
      }
    }, true);
    // a checkout link (not a form button) waits for the save too
    document.addEventListener('click', function (e) {
      var a = e.target && typeof e.target.closest === 'function' ? e.target.closest('a[href*="/checkout"]') : null;
      if (!a || go.has(a) || e.defaultPrevented) return;
      if (waitingForms.has(a)) { e.preventDefault(); return; }   // WO-726 P3-7
      var href = a.href;
      var blocked = waitThen(function () { go.add(a); window.location.assign(href); }, false, function () { waitingForms.delete(a); });
      if (blocked) { waitingForms.add(a); e.preventDefault(); }
    }, true);

    // ---- WO-706: nothing typed is lost on ANY way out ----
    // What a person has typed or picked in the gift card right now (the copies of the card mirror each other, the first one is enough).
    // WO-712b (3): a field whose input is not on the page (hidden by settings) is not empty, it is unknown here: it keeps the latest value queued or in flight, else the value the page was built with.
    function seedOf(key) {
      var c = cfg();
      var a = key === 'Gift to' ? 'data-seed-to' : key === 'Gift from' ? 'data-seed-from' : 'data-seed-occ';
      return c ? String(c.getAttribute(a) || '').trim() : '';
    }
    function fallbackOf(key) { return latest[key] !== undefined ? String(latest[key]) : seedOf(key); }
    function typed() {
      var f = function (sel, key) { var el = document.querySelector(sel); return el ? String(el.value || '').trim() : fallbackOf(key); };
      var occEls = document.querySelectorAll(OCC_SEL);
      var occ = document.querySelector(OCC_SEL + ':checked');
      return { 'Gift note': cut(String((document.querySelector(NOTE_SEL) || {}).value || '').trim(), msgLimit()), 'Gift to': f('[data-gift-to]', 'Gift to'), 'Gift from': f('[data-gift-from]', 'Gift from'), 'Gift occasion': occEls.length ? (occ ? String(occ.value || '').trim() : '') : fallbackOf('Gift occasion') };
    }
    function ownedAttributes(attrs) {
      if (attrs && KEYS.every(function (key) { return attrs[key] === ''; })) return lastCount === 0 && cleanupAnswer === cartAnswers ? Object.assign({}, attrs) : {};
      var current = typed();
      current.Gift = giftOn() ? 'yes' : 'no';
      current['Gift note'] = giftOn() ? noteAttr(current['Gift note'], current['Gift to'], current['Gift from']) : '';
      var owned = {};
      Object.keys(attrs || {}).forEach(function (key) { if (localEdits[key]) owned[key] = current[key]; });
      return owned;
    }
    // WO-712b (1): the page is leaving (pagehide, tab hidden): it will never get an answer, so the latest snapshot is sent NOW with keepalive, not queued behind a write that is still in flight
    // WO-715: the write still in flight is cancelled FIRST (a late older body must not land after the newer one: B in flight, reverted to A, page leaves: the cart ends A), a waiting retry is dropped
    function sendNow(snap, forceNote) {   // WO-735 (re-review): forceNote sends the current note even when it equals the one queued or in flight (that write is cancelled just below)
      snap = ownedAttributes(Object.assign({}, inflightAttrs || {}, pending || {}, snap));
      if (inflight) {
        // WO-730 (own LAW 51 review): the write that is cancelled here may hold attributes the snapshot does not (a Gift = no clear, with the gift OFF), and the note it carried is not confirmed: both go on in this body
        latestNote = null;
        inflight.cancelled = true; try { inflight.abort(); } catch (e) { /* already settled */ } inflight = null; inflightAttrs = null; inflightNote = null;
      }
      if (retryTimer) { clearTimeout(retryTimer); retryTimer = null; }
      var body = { attributes: snap };
      var wanted = noteTyped ? customerNow() : null;
      var customerEdited = noteTyped && (forceNote || wanted !== customerOf(latestNote !== null ? latestNote : baseNote()));
      var hasNote = customerEdited || Object.keys(snap).length > 0;
      if (customerEdited) latestNote = wanted;
      pending = null; noteDirty = false; saveRequested = false;
      Object.keys(snap).forEach(function (k) { latest[k] = snap[k]; });
      if (!Object.keys(snap).length && !hasNote) return;   // nothing to send (the typing pause was live but the text is what was already sent)
      writes++;
      var writeVersion = writes;
      var answerVersion = ++cartAnswers;
      var generation = editGeneration;
      immediateWrites++;
      // WO-730 (own LAW 51 review): the leaving write can be cancelled by a newer leaving write like a regular write (two of them in flight could land in the wrong order)
      var ctl2 = typeof AbortController === 'function' ? new AbortController() : null;
      inflight = ctl2;
      inflightAttrs = snap;
      var request;
      try {
        if (hasNote) body.note = composeCartNote(authoritativeCart, snap, customerEdited ? wanted : null);
        latestNote = body.note === undefined ? latestNote : body.note;
        inflightNote = body.note === undefined ? null : body.note;
        var initNow = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true };
        if (ctl2) initNow.signal = ctl2.signal;
        request = nativeFetch('/cart/update.js', initNow);
      } catch (err) { request = Promise.reject(err); }
      request.then(function (response) { if (!response.ok) throw new Error('Cart update failed'); return response.clone().json(); })
        .then(function (cart) {
          if (!cart || (ctl2 && ctl2.cancelled) || !currentAnswer(writeVersion, answerVersion)) return;
          // WO-730 P1.1 (LAW 55): saved means confirmed, an HTTP 200 whose cart does not hold the values sent is a failure
          if (!answerHolds(cart, snap, body.note === undefined ? null : body.note)) { var bad = new Error('Cart answer does not hold the values sent'); bad.mismatch = true; throw bad; }
          Object.keys(snap).forEach(function (k) { known[k] = snap[k]; confirmed[k] = snap[k]; });
          if (body.note !== undefined) confirmedNote = body.note;
          confirmedEdits(snap, body.note === undefined ? null : body.note);
          announceSaved(snap);   // WO-779 (Codex R5 P2): the checkout and tab-hide rescue save is a confirmed save too
          noteCart(cart);
          if (currentAnswer(writeVersion, answerVersion)) adoptServerValues(cart);
          gaveUp = false;
          showSaveError(false);
        })
        .catch(function (err) {
          if (ctl2 && ctl2.cancelled) return;
          if (!currentAnswer(writeVersion, answerVersion) || editGeneration !== generation) { requeueCurrent(); return; }
          leaveFailed(err && err.mismatch);
        })
        .then(function () {
          if (inflight === ctl2) { inflight = null; inflightAttrs = null; inflightNote = null; }
          immediateWrites--;
          if (!gaveUp && !saving && !immediateWrites && (pending || noteDirty || saveRequested)) flush();
          notify();
        });
      // WO-726 P3-3: a page that is really leaving never sees this; a page that came back (a hidden tab shown again) keeps the snapshot queued and shows the error, it is not taken as saved
      function requeueCurrent() {
        if (ctl2 && ctl2.cancelled) return;
        var intent = Object.assign({}, snap, pending || {});
        KEYS.forEach(function (key) { if (localEdits[key]) intent[key] = true; });
        var owned = ownedAttributes(intent);
        pending = Object.keys(owned).length ? owned : null;
        if (pending) noteDirty = true;
        if (hasNote) noteDirty = true;
      }
      function leaveFailed(mismatch) {
        // WO-726 P2-B: queued again whatever the tab state (a page that is really leaving never runs this, so nothing is lost by it); the error shows only when someone can see it
        pending = pending || {};
        var owned = ownedAttributes(snap);
        Object.keys(owned).forEach(function (k) { if (!(k in pending)) pending[k] = owned[k]; });
        if (hasNote) noteDirty = true;
        gaveUp = true;
        lastGiveUpMismatch = !!mismatch;
        // the gift error belongs to a write with gift attributes, never to a note-only body (a customer who never used a gift)
        if (document.visibilityState !== 'hidden' && Object.keys(snap).length) showSaveError(true);
      }
    }
    function rescue(leaving) {
      if (suppress) return;
      var v = typed();
      var any = !!(v['Gift note'] || v['Gift to'] || v['Gift from'] || v['Gift occasion']);
      // WO-711 finding 4: an order note edit (a pending typing pause, or a box that differs from what the cart holds) is flushed on every exit, with the gift on or off
      var box = document.querySelector('textarea[name="note"]');
      // WO-735 v5 (review P1-C): an untouched page never writes its note on the way out (a stale tab would put an old snapshot over a newer gift); the old block of a saved gift gets its Gift note line at load (repairNoMessageOnLoad below)
      var notePending = noteTyped && (!!timerLive['order note'] || (!!box && wantedNote() !== (latestNote !== null ? latestNote : baseNote())));
      var giftEdited = KEYS.some(function (key) { return !!localEdits[key]; });
      if (!giftOn()) {
        // a new gift with words in it: the card turns the gift on and saves everything (mezuzah-gift-preview.liquid), the note goes in the same body
        if (any && giftEdited && window.mezGiftAutoSave) {
          if (notePending) { clearT('order note'); noteDirty = true; }
          window.mezGiftAutoSave();
          if (leaving === true && giftOn()) rescue(true);
          return;
        }
        if (giftEdited || notePending) {
          Object.keys(timers).forEach(function (key) { clearT(key); });
          var offIntent = {};
          KEYS.forEach(function (key) { if (localEdits[key]) offIntent[key] = true; });
          var offAttrs = ownedAttributes(offIntent);
          // WO-730 P1.3 (review): leaving while an earlier note write is busy, the newest note goes out NOW (flush would keep it queued in a page that is about to be destroyed)
          if (leaving === true) sendNow(offAttrs, notePending);
          else { noteDirty = true; if (Object.keys(offAttrs).length) saveCartAttributes(offAttrs, true); else flush(); }
        }
        return;
      }
      if (!giftEdited && !notePending) return;
      if (notePending && !giftEdited) { clearT('order note'); if (leaving === true) sendNow({}, true); else { noteDirty = true; flush(); } return; }
      // Queue only unresolved local edits without waiting for the typing pause. Compare with the latest queued or in-flight values so a reverted edit wins over an older write.
      // Every edited gift field also rebuilds the printed block; leaving uses the server snapshot already in hand.
      Object.keys(timers).forEach(function (k) { clearT(k); });
      var snap = ownedAttributes({ 'Gift': 'yes', 'Gift note': noteAttr(v['Gift note'], v['Gift to'], v['Gift from']), 'Gift to': v['Gift to'], 'Gift from': v['Gift from'], 'Gift occasion': v['Gift occasion'] });
      var differs = Object.keys(snap).some(function (k) { return String(latest[k] || '') !== snap[k]; });
      if (leaving === true && giftEdited && !inflight) { sendNow(snap, notePending); return; }
      if (differs || notePending || gaveUp) {
        if (leaving === true) { sendNow(snap, notePending); return; }
        if (notePending) noteDirty = true;
        saveCartAttributes(snap, true);
      }
    }
    // Any checkout button, checkout link and every dynamic checkout button (Shop Pay, Apple Pay, Google Pay, PayPal: custom elements and frames
    // that are not form submits and cannot be waited for) starts the rescue the moment a finger or a key goes down on it, before the click.
    var EXIT_SEL = 'a[href*="/checkout"], [name="checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-buy-it-now-button, shop-pay-wallet-button, [data-shopify="payment-button"], .shopify-payment-button, .additional-checkout-buttons, .dynamic-checkout__content, .cart__checkout, .cart__additional-checkout, .cart__view';
    function onExit(e) {
      var t = e.target;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (t && t.closest && t.closest(EXIT_SEL)) rescue(e.type !== 'focusin');
    }
    ['pointerdown', 'mousedown', 'touchstart', 'focusin', 'keydown'].forEach(function (type) { document.addEventListener(type, onExit, true); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') rescue(true); });
    window.addEventListener('pagehide', function () { rescue(true); });

    // a tab that was in the background may have an older idea of what the cart holds
    // WO-719 GFT-05 (review): two tabs. A stale tab used to post ITS old order note text (plus the gift block) after the other tab saved a newer one, overwriting it. When the tab comes back it reads the cart,
    // and when nothing is being typed or sent here (the box still holds the customer text this tab last knew, no write queued or in flight) it takes the cart's note as what it knows and shows its customer
    // text in the box. A draft typed here is kept (the last writer wins, nothing typed is thrown away).
    // WO-730 P1.2 (review, with the CTO's guard): the gift UI follows the server when the gift was removed elsewhere. ONLY when this tab last knew Gift = yes from the server (known.Gift before the read),
    // the cart now says it is not yes, and nothing is queued, typed or in flight here: a gift being composed but not saved yet (card open, Save not pressed) is never cleared by a tab switch.
    function clearGiftUi() {
      suppress++;
      try {
        document.querySelectorAll(TOGGLE_SEL).forEach(function (t) { if (t.checked) { t.checked = false; t.dispatchEvent(new Event('change', { bubbles: true })); } });
        FIELDS.forEach(function (field) { document.querySelectorAll(field.sel).forEach(function (el) { if (el.value !== '') { el.value = ''; announce(el); } }); });
        document.querySelectorAll(OCC_SEL).forEach(function (r) { if (r.checked) { r.checked = false; announce(r); } });
        KEYS.forEach(function (k) { known[k] = ''; latest[k] = ''; confirmed[k] = ''; });
        syncHidden();
        document.dispatchEvent(new Event('mezgift:cleared'));
      } finally { suppress--; }
    }
    // A fresh answer owns every untouched field, even its focused copy. Edits remain local until their own answer confirms them.
    function adoptServerValues(cart) {
      if (!cart || !cart.attributes) return;
      rememberCart(cart);
      var a = cart.attributes;
      var cleanup = function (attrs) { return attrs && KEYS.every(function (key) { return attrs[key] === ''; }); };
      if (cart.item_count > 0) { cleanupActive = false; if (cleanup(pending)) { pending = null; if (!noteTyped) noteDirty = false; } }
      if (cart.item_count === 0 && (cleanupActive || cleanup(pending) || cleanup(inflightAttrs))) {
        if (!noteTyped && typeof cart.note === 'string') {
          confirmedNote = cart.note; latestNote = null;
          document.querySelectorAll('textarea[name="note"]').forEach(function (box) { box.value = customerOf(cart.note); });
        }
        return;
      }
      var rebase = false;
      var hasGiftEdit = KEYS.some(function (key) { return !!localEdits[key]; });
      if (!hasGiftEdit && known.Gift === 'yes' && String(a.Gift || '') !== 'yes' && giftOn()) clearGiftUi();
      if (!hasGiftEdit && String(a.Gift || '') === 'yes' && !giftOn()) {
        suppress++;
        try { document.querySelectorAll(TOGGLE_SEL).forEach(function (toggle) { toggle.checked = true; toggle.dispatchEvent(new Event('change', { bubbles: true })); }); } finally { suppress--; }
      }
      if (!localEdits['Gift note']) {
        serverMessage = !norm(a['Gift note']) || norm(a['Gift note']) === norm(noMsgText()) ? blockMessage(cart.note || '', a) : null;
        if (serverMessage && pending && !repairPending) { delete pending['Gift note']; if (!Object.keys(pending).length) pending = null; }
      }
      FIELDS.forEach(function (field) {
        if (localEdits[field.key]) return;
        var value = String(a[field.key] || '');
        if (norm(value) !== norm(known[field.key])) rebase = true;
        known[field.key] = value; latest[field.key] = value; confirmed[field.key] = value;
        if (field.key === 'Gift note' && norm(value) && norm(value) !== norm(noMsgText()) && pending && !repairPending && Object.prototype.hasOwnProperty.call(pending, field.key)) { delete pending[field.key]; if (!Object.keys(pending).length) pending = null; }
        var shown = field.key === 'Gift note' && norm(value) === norm(noMsgText()) ? '' : value;
        cleanDisplay[field.key] = shown;
        document.querySelectorAll(field.sel).forEach(function (el) { if (el.value !== shown) { el.value = shown; announce(el); } });
      });
      if (!localEdits['Gift occasion']) {
        var occasion = String(a['Gift occasion'] || '');
        if (norm(occasion) !== norm(known['Gift occasion'])) rebase = true;
        known['Gift occasion'] = occasion; latest['Gift occasion'] = occasion; confirmed['Gift occasion'] = occasion;
        document.querySelectorAll(OCC_SEL).forEach(function (radio) { var checked = !!occasion && radio.value === occasion; if (radio.checked !== checked) { radio.checked = checked; announce(radio); } });
      }
      if (!hasGiftEdit) { known.Gift = String(a.Gift || ''); latest.Gift = known.Gift; confirmed.Gift = known.Gift; }
      if (!noteTyped && typeof cart.note === 'string') {
        if (customerOf(cart.note) !== customerOf(baseNote())) rebase = true;
        confirmedNote = cart.note; latestNote = null;
        document.querySelectorAll('textarea[name="note"]').forEach(function (box) { box.value = customerOf(cart.note); });
      }
      // An emptied cart already queued its cleanup behind this write; that queue keeps both requests serialized.
      if (rebase && (hasGiftEdit || noteTyped) && cart.item_count !== 0 && inflight && inflightNote !== null && !inflight.cancelled && !inflight.repair) {
        pending = pending || {};
        Object.keys(inflightAttrs || {}).forEach(function (key) { if (localEdits[key] && !(key in pending)) pending[key] = inflightAttrs[key]; });
        noteDirty = true;
        inflight.cancelled = true; try { inflight.abort(); } catch (err) { /* already settled */ }
      }
      syncHidden();
    }
    var freshCards = new WeakMap();
    if (window.MutationObserver) new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) { mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var roots = node.matches('[data-mz-gp]') ? [node] : node.querySelectorAll('[data-mz-gp]');
        Array.prototype.forEach.call(roots, function (root) {
          var c = root.nextElementSibling;
          if (!c || !c.matches('[data-gift-note-config]')) c = null;
          var attrs = {};
          FIELDS.forEach(function (field) { var input = root.querySelector(field.sel); attrs[field.key] = input ? input.defaultValue : String((known || {})[field.key] || ''); });
          var occasion = root.querySelector(OCC_SEL + '[checked]');
          attrs['Gift occasion'] = occasion ? occasion.value : '';
          attrs.Gift = c ? String(c.getAttribute('data-seed-gift') || '') : String(known.Gift || '');
          var shown = Object.assign({}, attrs);
          if (norm(shown['Gift note']) === norm(noMsgText())) shown['Gift note'] = '';
          freshCards.set(root, shown);
          refreshNoteFromServer(true);
          setTimeout(function () { freshCards.delete(root); }, 0);
        });
      }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
    function refreshNoteFromServer(force) {
      var box = document.querySelector('textarea[name="note"]');
      var wantNote = !!box && noteEnabled();
      var knewGift = known.Gift === 'yes' && giftOn();
      if ((!wantNote && !knewGift) || !window.fetch) return;
      // WO-726 P3-8 and the LAW 51 re-review (P2-A): a cart that has items (or a saved gift here) and the throttle (1 s) only dedupes the focus plus visibility pair;
      // a longer throttle or a gift or touched gate let a stale tab overwrite a newer order note again (GFT-05)
      if (!force && !(lastCount > 0) && !knewGift) return;
      if (!force && Date.now() - lastNoteRefresh < 1000) return;
      if (!force) lastNoteRefresh = Date.now();   // the read at load does not use up the throttle
      var w = writes;
      var answer = cartAnswers;
      nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          if (writes !== w || cartAnswers !== answer) return;   // a write started after this read was issued: the answer may be older than the cart, it must not put an old note back
          adoptServerValues(cart);
        })
        .catch(function () { /* the next focus tries again */ });
    }
    window.addEventListener('focus', function () { confirmed = {}; refreshNoteFromServer(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshNoteFromServer(); });

    function notePayload(body) {
      var params = null;
      var kind = '';
      if (typeof FormData === 'function' && body instanceof FormData) {
        params = new FormData(); body.forEach(function (value, key) { params.append(key, value); }); kind = 'form';
      } else if (typeof URLSearchParams === 'function' && body instanceof URLSearchParams) {
        params = new URLSearchParams(body.toString()); kind = 'params';
      }
      var data = null;
      if (typeof body === 'string') {
        try { data = JSON.parse(body); } catch (err) { params = new URLSearchParams(body); kind = 'text'; }
      }
      var owned = {};
      if (params) {
        if (!params.has('note')) return null;
        params.forEach(function (value, key) { var match = /^attributes\[(.+)\]$/.exec(key); if (match) owned[match[1]] = String(value); });
        return { customer: customerOf(String(params.get('note') || '')), owned: owned, multipart: kind === 'form', encode: function (note) { params.set('note', note); return kind === 'text' ? params.toString() : params; } };
      }
      if (!data || typeof data !== 'object' || !Object.prototype.hasOwnProperty.call(data, 'note')) return null;
      owned = Object.assign({}, data.attributes || {});
      Object.keys(data).forEach(function (key) { var match = /^attributes\[(.+)\]$/.exec(key); if (match) owned[match[1]] = String(data[key]); });
      return { customer: customerOf(String(data.note || '')), owned: owned, multipart: false, encode: function (note) { return JSON.stringify(Object.assign({}, data, { note: note })); } };
    }
    function readNotePayload(input, init) {
      if (init && Object.prototype.hasOwnProperty.call(init, 'body')) return notePayload(init.body);
      if (typeof Request !== 'function' || !(input instanceof Request) || input.method === 'GET' || input.method === 'HEAD') return null;
      var copy = input.clone();
      var type = copy.headers.get('Content-Type') || '';
      return (type.indexOf('multipart/form-data') !== -1 ? copy.formData() : copy.text()).then(function (body) { return notePayload(body); });
    }
    // ---- fetch: keep the gift block in any note post, and watch every cart answer for an emptied cart ----
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function (input, init) {
        var url = '';
        var payload = null;
        try {
          url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart(?:\/(update|change)(\.js)?)?(\?|$)/.test(url) && !skipWrap) payload = readNotePayload(input, init);
        } catch (err) { /* leave the request untouched */ }
        var nativePost = /\/cart(\?|$)/.test(url) && String((init && init.method) || (input && input.method) || 'GET').toUpperCase() !== 'GET';
        var cartWrite = nativePost || /\/cart\/(add|update|change)(\.js)?(\?|$)/.test(url);
        var answer = cartWrite ? ++cartAnswers : cartAnswers;
        var w = writes;
        var generation = editGeneration;
        var self = this;
        var p;
        function dispatchNote(body) {
          if (!body) return nativeFetch.call(self, input, init);
          return nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
            .then(function (response) { if (!response.ok) throw new Error('Cart answer unreadable'); return response.json(); })
            .then(function (cart) {
              if (!currentAnswer(w, answer) || editGeneration !== generation || !noteSnapshot(cart)) throw new Error('Cart answer unreadable');
              rememberCart(cart);
              var next = Object.assign({}, init || {}, { body: body.encode(composeCartNote(cart, body.owned, body.customer)) });
              if (body.multipart) {
                var headers = new Headers((init && init.headers) || (input && input.headers) || {});
                headers.delete('Content-Type'); next.headers = headers;
              }
              return nativeFetch.call(self, input, next);
            });
        }
        p = payload && typeof payload.then === 'function' ? payload.then(dispatchNote) : dispatchNote(payload);
        if (cartWrite) {
          var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
          p.then(function (response) {
            if (!response || !response.ok || !currentAnswer(w, answer) || (init && init.signal && init.signal.aborted)) return;
            response.clone().json().then(function (cart) {
              if (!currentAnswer(w, answer) || (init && init.signal && init.signal.aborted)) return;
              if (isAdd) lastCount = Math.max(lastCount || 0, 1);
              noteCart(cart);
              if (currentAnswer(w, answer)) adoptServerValues(cart);
            }, function () {});
          }, function () {});
        }
        return p;
      };
    }

    // start-up: how many items the cart had when the page was built, and the hidden inputs in step with the switch
    (function () {
      var c = cfg();
      var n = c ? parseInt(c.getAttribute('data-items'), 10) : NaN;
      if (!isNaN(n)) lastCount = n;
      // what the page was built with is what the cart holds
      if (giftOn()) { known = typed(); known['Gift note'] = noteAttr(known['Gift note'], known['Gift to'], known['Gift from']); known.Gift = 'yes'; latest = {}; Object.keys(known).forEach(function (k) { latest[k] = known[k]; }); }
      var attrs;
      try { attrs = c ? JSON.parse(c.getAttribute('data-attributes') || '{}') : {}; } catch (err) { attrs = Object.assign({}, known); }
      rememberCart({ attributes: attrs, note: c ? c.getAttribute('data-note') || '' : '', item_count: lastCount });
      cleanDisplay = typed();
      syncHidden();
      document.addEventListener('DOMContentLoaded', syncHidden);
      document.addEventListener('mezgift:sync', syncHidden);
    })();

    // WO-726 F2 and F3 (Chrome check on V36): on load the SERVER note wins. A value the browser restored into the box (reload, back) is not typed on this page and goes back to what the page
    // was built with, then the cart is read (the page HTML itself may be older than the cart) and an untouched box takes the cart's note. A gift block left in the note while the cart has no
    // gift (Gift is not yes, for example after an outside write or an emptied cart) is removed. Typed text is never touched.
    function adoptServerNoteOnLoad() {
      var box = document.querySelector('textarea[name="note"]');
      if (!box || !noteEnabled()) return;
      // WO-726 round 3 (P2-1): what this page knows, not the HTML text: after a back cache restore the page may have adopted a newer server note than its HTML holds (on a fresh load the two are the same)
      var knownText = customerOf(baseNote());
      if (!noteTyped && box.value !== knownText) box.value = knownText;
      refreshNoteFromServer(true);
      var c = cfg();
      var seedGift = c ? String(c.getAttribute('data-seed-gift') || '') : 'yes';
      if (seedGift !== 'yes' && findBlock(baseNote()) && !noteTyped) { noteDirty = true; flush(); }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adoptServerNoteOnLoad); else adoptServerNoteOnLoad();
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) adoptServerNoteOnLoad(); });

    // WO-735 v5 (review P1-C, CTO design): a saved gift whose message is empty gets "No message" in its Gift note attribute and in its order note block AT LOAD, where the page can wait for the answer,
    // not on the way out (an untouched stale tab must never write). The cart is read once (no-store); the write is queued ONLY when every one of these holds: no write of this page started meanwhile and nothing is
    // queued or typed here, the cart says Gift = yes, its To, From and occasion are exactly what this page knows, and its Gift note is empty. Anything else (gift changed or removed elsewhere, a real message
    // present) writes nothing. The note is rebuilt from the SERVER's note (its customer text is kept), in the same body as the attribute (LAW 53), through the normal queue (verified, retried, LAW 55).
    // WO-735 v6 (recheck): the repair is validated INSIDE the queue, right before it is sent: the cart is read again and the write goes only if Gift is still yes, Gift note is still empty and To, From and
    // occasion still match; the order note is then rebuilt on that fresh note. A failed read, a write of this page started meanwhile, or any difference drops the repair (nothing is sent).
    var repairValue = null;
    var repairPending = false;
    function repairStillValid(cart) {
      var a = (cart && cart.attributes) || {};
      if (String(a.Gift || '') !== 'yes' || String(a['Gift note'] || '').trim() !== '') return false;
      var block = findBlock(cart.note || '');
      if (block) {
        var c = cfg();
        var lines = [String(c.getAttribute('data-heading') || '').trim(), 'Gift note: ' + clean(noMsgText())];
        [['data-to', 'Gift to'], ['data-from', 'Gift from'], ['data-occasion', 'Gift occasion']].forEach(function (pair) {
          if (clean(a[pair[1]])) lines.push(String(c.getAttribute(pair[0]) || '') + ': ' + clean(a[pair[1]]));
        });
        if (String(cart.note).slice(block[0].end, block[1].start).split(/\r?\n/).some(function (line) { return line.trim() && lines.indexOf(line.trim()) === -1; })) return false;
      }
      var v = typed();
      if (v['Gift note']) return false;
      return ['Gift to', 'Gift from', 'Gift occasion'].every(function (k) { var s = String(a[k] == null ? '' : a[k]).trim(); return s === String(known[k] == null ? '' : known[k]).trim() && s === v[k]; });
    }
    // WO-735 v6b (V36 verdict): the repair keeps its intent (repairValue) through retries and is checked before EVERY send attempt and against every fresh guard read; it is cancelled the moment the cart
    // is no longer eligible, and its order note is rebuilt on the CURRENT server note each time, never on a stored copy.
    var repairChecked = false;
    function cancelRepair() {
      var value = repairValue;
      repairValue = null; repairChecked = false;
      if (value !== null && repairPending && pending && pending['Gift note'] === value) {
        delete pending['Gift note'];
        latest['Gift note'] = known['Gift note'];
        if (!Object.keys(pending).length) { pending = null; if (!noteTyped && !timerLive['order note']) noteDirty = false; }
      }
      repairPending = false;
      if (value !== null && inflight && inflight.repair) { inflight.cancelled = true; try { inflight.abort(); } catch (err) { /* already settled */ } }
    }
    function checkRepairThenFlush() {
      saving = true;
      var w = writes;
      var answer = cartAnswers;
      var generation = editGeneration;
      nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { return cart; }, function () { return null; })
        .then(function (cart) {
          saving = false;
          if (repairRetired || editGeneration !== generation || repairValue === null) { if (cart && writes === w && cartAnswers === answer) adoptServerValues(cart); flush(); return; }
          var ok = !!cart && writes === w && cartAnswers === answer && repairStillValid(cart);
          if (ok && noteEnabled() && typeof cart.note === 'string') {
            if (noteTyped) ok = false;
            else { confirmedNote = cart.note; latestNote = null; document.querySelectorAll('textarea[name="note"]').forEach(function (box) { box.value = customerOf(cart.note); }); }
          }
          if (ok) repairChecked = true; else cancelRepair();   // dropped: only the repair's own value leaves the queue
          if (cart && writes === w && cartAnswers === answer) adoptServerValues(cart);
          flush();
        });
    }
    function repairNoMessageOnLoad() {
      var t = noMsgText();
      if (!t || !window.fetch || repairRetired || known.Gift !== 'yes' || !giftOn()) return;
      var w = writes;
      var answer = cartAnswers;
      var generation = editGeneration;
      nativeFetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.attributes || writes !== w || cartAnswers !== answer) return;
          if (repairRetired || editGeneration !== generation) { adoptServerValues(cart); return; }
          if (saving || immediateWrites || pending || noteDirty || retryTimer || onlineWait || anyTimer() || suppress) return;
          var eligible = repairStillValid(cart);
          adoptServerValues(cart);
          if (!eligible) return;
          var v = typed();
          if (v['Gift note']) return;   // a message is being typed here
          if (noteEnabled() && typeof cart.note === 'string') {
            var box = document.querySelector('textarea[name="note"]');
            if (noteTyped) return;
            confirmedNote = cart.note;   // the server's note is what the cart holds; the block is rebuilt on top of its customer text
            latestNote = null;
            if (box) box.value = customerOf(cart.note);
          }
          repairValue = t;
          repairPending = true;
          saveCartAttributes({ 'Gift note': t }, true);
        })
        .catch(function () { /* nothing is written, the next load tries again */ });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repairNoMessageOnLoad); else repairNoMessageOnLoad();

    // WO-711 finding 21: does the cart hold exactly these values right now? (reads, writes nothing)
    function verify(values) {
      var expected = effExpected(values);
      return readBack(expected).catch(function () { return false; });
    }

    window.mezGift = { verify: verify, saveNow: saveNow, settle: settle, readBack: readBack, idle: idle, chars: chars, cut: cut, rescue: rescue };
  })();

  (function () {
    if (window.__mzGp) return;
    window.__mzGp = true;
    var snaps = new WeakMap();

    function set(root, key, value) {
      root.querySelectorAll('[data-gp-p="' + key + '"]').forEach(function (el) { el.textContent = value; });
      root.querySelectorAll('[data-gp-chip="' + key + '"]').forEach(function (el) { el.hidden = !String(value).trim(); });
    }
    function values(root) {
      var to = root.querySelector('[data-gift-to]');
      var from = root.querySelector('[data-gift-from]');
      var note = root.querySelector('[data-gift-note]');
      var occ = root.querySelector('[data-gift-occasion]:checked');
      return { to: to ? to.value : '', from: from ? from.value : '', note: note ? note.value : '', occ: occ ? occ.value : '' };
    }
    function hasText(v) { return !!(v.to || v.from || v.note || v.occ); }
    function refresh(root) {
      var v = values(root);
      set(root, 'to', v.to);
      set(root, 'from', v.from);
      set(root, 'msg', v.note);
      set(root, 'occ', v.occ);
      var count = root.querySelector('[data-gp-count]');
      if (count) count.textContent = Array.from(v.note).length;   // WO-699 F6: characters, an emoji is 1
    }
    function rootOf(el) { return el && el.closest ? el.closest('[data-mz-gp]') : null; }
    // WO-757: return focus only when this card still owns the control being hidden.
    function focusVisibleAction(root) {
      if (!root.isConnected) return;
      var state = root.getAttribute('data-state');
      var action = state === 'saved' ? 'edit' : 'open';
      var target = root.querySelector('[data-gp-act="' + action + '"]');
      if (!target || target.disabled || !target.getClientRects().length) {
        target = state === 'saved' ? root.querySelector('[data-gp-act="remove"]') : null;
      }
      if (target && !target.disabled && target.getClientRects().length) {
        target.focus({ preventScroll: true });
      } else {
        root.setAttribute('tabindex', '-1');
        root.focus({ preventScroll: true });
      }
    }
    function confirmBox(root, show, returnFocus) {
      var c = root.querySelector('[data-gp-confirm]');
      if (!c) return;
      var ownedFocus = c.contains(document.activeElement);
      if (show) root.__mzConfirmTrigger = root.contains(document.activeElement) ? document.activeElement : null;
      c.hidden = !show;
      if (show) {
        var keep = c.querySelector('[data-gp-act="keep"]');
        if (keep) keep.focus();
      } else {
        if (ownedFocus && returnFocus !== false && root.isConnected) {
          var trigger = root.__mzConfirmTrigger;
          if (trigger && trigger.isConnected && !trigger.disabled && trigger.getClientRects().length) {
            trigger.focus({ preventScroll: true });
          } else {
            focusVisibleAction(root);
          }
        }
        root.__mzConfirmTrigger = null;
      }
    }
    function showError(show) {
      document.querySelectorAll('[data-gift-save-error]').forEach(function (el) { el.hidden = !show; });
    }
    function setState(root, state) {
      var active = document.activeElement;
      var restoreFocus = active && root.contains(active) && (
        (state !== 'editing' && active.closest('.mz-gp__reveal')) ||
        (state === 'closed' && active.closest('.mz-gp__summary')) ||
        active.closest('[data-gp-confirm]')
      );
      root.setAttribute('data-state', state);
      if (state !== 'editing') clearTimeout(root.__mzFocusT);   // WO-719 PERF-03: a pending focus of the first field is cancelled when the form closes
      root.classList.toggle('is-open', state !== 'closed');
      // WO-682 a11y: the open, edit and check buttons say whether the form is open (true only while editing).
      root.querySelectorAll('[data-gp-act="open"], [data-gp-act="edit"]').forEach(function (btn) { btn.setAttribute('aria-expanded', state === 'editing' ? 'true' : 'false'); });
      confirmBox(root, false, false);
      if (restoreFocus) focusVisibleAction(root);
    }
    function toggleOf(root) { return root.querySelector('[data-gift-toggle]'); }
    // WO-709 A2: with quiet, turning the gift ON is interface state only (every copy of the card follows) and the sync routine does not post a flag-only write;
    // the caller sends ONE complete snapshot (Gift plus the four fields and the note block in one /cart/update.js body) with mezGift.saveNow.
    function setGift(root, on, quiet) {
      var t = toggleOf(root);
      if (!t || t.checked === on) return;
      t.checked = on;
      if (quiet) window.__mezGiftQuiet = true;
      try { t.dispatchEvent(new Event('change', { bubbles: true })); } finally { if (quiet) window.__mezGiftQuiet = false; }
    }
    function focusFirst(root, trigger) {
      var el = root.querySelector('.mz-gp__body input:not([type="radio"]), .mz-gp__body textarea');
      if (!el) return;
      // WO-719 PERF-03 (review): the delayed focus runs only while the card is still on the page and still editing (a redraw of the drawer or a Cancel in the 360 ms must not focus a removed or hidden field)
      clearTimeout(root.__mzFocusT);
      root.__mzFocusT = setTimeout(function () {
        if (!root.isConnected || !el.isConnected || root.getAttribute('data-state') !== 'editing') return;
        // WO-735 (LANE-QA saw Gift to = RivkaShay at 390): a fast customer may already be in To, From or the message box within these 360 ms; the delayed focus never moves a focus that is already in a field
        // WO-735 v4 (re-review): the delayed focus only fires when the focus is still where the click left it (the trigger button, or nothing: body or html); a customer who opened the card with Enter and
        // tabbed on (to Save, a field, a link) keeps the focus they chose
        var ae = document.activeElement;
        if (ae && ae !== trigger && ae !== document.body && ae !== document.documentElement) return;
        el.focus({ preventScroll: true });
      }, 360);
    }
    // Puts back the values saved before Edit, through the same events the save routine listens to.
    function restore(root, s) {
      [['[data-gift-to]', s.to], ['[data-gift-from]', s.from], ['[data-gift-note]', s.note]].forEach(function (pair) {
        var el = root.querySelector(pair[0]);
        if (!el || el.value === pair[1]) return;
        el.value = pair[1];
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
      });
      // WO-709 A4: every radio gets an explicit state (checked only when it is the saved occasion), so an empty saved occasion is restored too
      var flipped = [];
      root.querySelectorAll('[data-gift-occasion]').forEach(function (r) {
        var want = Boolean(s.occ) && r.value === s.occ;
        if (r.checked !== want) { r.checked = want; flipped.push(r); }
      });
      if (flipped.length) {
        var lead = flipped.filter(function (r) { return r.checked; })[0] || flipped[0];
        lead.dispatchEvent(new Event('change', { bubbles: true }));
      }
      refresh(root);
    }
    // A new gift that is thrown away was never saved: just empty every copy of the fields.
    function discard(root) {
      document.querySelectorAll('[data-gift-to], [data-gift-from], [data-gift-note]').forEach(function (el) {
        if (el.value !== '') { el.value = ''; el.dispatchEvent(new Event('mezgift:sync', { bubbles: true })); }
      });
      document.querySelectorAll('[data-gift-occasion]:checked').forEach(function (r) { r.checked = false; r.dispatchEvent(new Event('mezgift:sync', { bubbles: true })); });
      setState(root, 'closed');
      refresh(root);
    }

    // WO-699 F9: what a person is typing survives a redraw of the cart drawer (quantity change, remove). It lives in sessionStorage
    // under the cart token and is cleared on Save, Cancel, Remove and when the cart empties.
    var store = {
      key: function () { var m = document.cookie.match(/(?:^|; )cart=([^;]+)/); return 'mezGift:' + (m ? m[1] : 'anon'); },
      put: function (root) {
        try {
          var v = values(root);
          sessionStorage.setItem(this.key(), JSON.stringify({ open: root.getAttribute('data-state') === 'editing', to: v.to, from: v.from, note: v.note, occ: v.occ }));
        } catch (err) { /* no storage */ }
      },
      get: function () { try { var s = sessionStorage.getItem(this.key()); return s ? JSON.parse(s) : null; } catch (err) { return null; } },
      clear: function () { try { sessionStorage.removeItem(this.key()); } catch (err) { /* no storage */ } }
    };
    document.addEventListener('mezgift:cleared', function () { removeGen++; store.clear(); });

    ['input', 'change', 'mezgift:sync'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var root = rootOf(e.target);
        if (!root) return;
        refresh(root);
        if (root.getAttribute('data-state') === 'editing') store.put(root);
      });
    });

    // The gift switch changed (here or on another copy of the card): every card on the page follows.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-gift-toggle]')) return;
      document.querySelectorAll('[data-mz-gp]').forEach(function (root) {
        if (!t.checked) { snaps.delete(root); setState(root, 'closed'); return; }
        // WO-712 P2-C / LAW 55: another copy of the card follows the switch by OPENING (editing); a card shows saved only after the cart answer holds the same values (see doSave)
        if (root.getAttribute('data-state') === 'closed') setState(root, 'editing');
      });
    });

    // WO-699 F2: Save shows a saving state and turns the card to "saved" only after the cart holds exactly these values.
    function doSave(root, btn) {
      root.__auto = false;   // WO-706: a Save is the person's own confirmation
      var v = values(root);
      if (btn) btn.disabled = true;
      root.setAttribute('aria-busy', 'true');
      showError(false);
      setGift(root, true, true);   // WO-709 A2: interface state only; saveNow below sends the one full snapshot
      var run = window.mezGift ? window.mezGift.saveNow(v) : Promise.resolve(false);   // WO-712 P2-C: no persistence code is a failure, never a success
      return run.then(function (ok) {
        if (btn) btn.disabled = false;
        root.removeAttribute('aria-busy');
        if (ok) {
          // WO-712b (2): a card shows saved ONLY when its own current values equal the values this save confirmed (the cart answer is about v, not about what is typed now);
          // one that was edited meanwhile stays editing and keeps its Cancel snapshot
          var sameAsConfirmed = function (r) { var c = values(r); return c.to === v.to && c.from === v.from && c.note === v.note && c.occ === v.occ; };
          if (sameAsConfirmed(root)) {
            snaps.delete(root);
            store.clear();
            setState(root, 'saved');
            refresh(root);
            showError(false);
          } else {
            setState(root, 'editing');
          }
          // the cart now holds v: every other copy of the card that follows the same gift and still shows v can show saved too
          document.querySelectorAll('[data-mz-gp]').forEach(function (other) {
            var ot = toggleOf(other);
            if (other !== root && ot && ot.checked && other.getAttribute('data-state') === 'editing' && sameAsConfirmed(other)) { snaps.delete(other); setState(other, 'saved'); refresh(other); }
          });
        } else {
          setState(root, 'editing');
          showError(true);
        }
        return ok;
      });
    }
    // WO-699 F4: an Add to cart while a NEW gift is open with words in it counts as Save (the routine in the sync waits for it).
    window.mezGiftAutoSave = function () {
      var ps = [];
      document.querySelectorAll('[data-mz-gp][data-state="editing"]').forEach(function (root) {
        var t = toggleOf(root);
        if (t && !t.checked && hasText(values(root))) ps.push(doSave(root, null));
      });
      return ps.length ? Promise.all(ps) : null;
    };

    // WO-706: words in an open new gift are written after a short pause, without Save (the card still reads "editing" until Save).
    var autoTimers = new WeakMap();
    var removeGen = 0;   // WO-712 P1-E: bumped when a gift is removed or cleared; an autosave timer started before that never writes
    function autoSave(root) {
      if (!root.isConnected) return;   // the card was replaced (a redraw of the drawer): its timer must not write
      if (root.getAttribute('data-state') !== 'editing') return;
      var t = toggleOf(root);
      if (!t) return;
      var v = values(root);
      if (!t.checked) {
        if (!hasText(v)) return;
        root.__auto = true;
        setGift(root, true, true);   // WO-709 A2: interface state only; saveNow sends Gift and every field in one body
        if (window.mezGift) window.mezGift.saveNow(v).then(function (ok) { showError(!ok); });
      } else if (root.__auto && !hasText(v)) {
        root.__auto = false;   // the words were taken out again: the gift goes back to off
        setGift(root, false);
      }
    }
    ['input', 'change'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var root = rootOf(e.target);
        if (!root || !e.target.matches || !e.target.matches('[data-gift-note], [data-gift-to], [data-gift-from], [data-gift-occasion]')) return;
        clearTimeout(autoTimers.get(root));
        var gen = removeGen;
        autoTimers.set(root, setTimeout(function () { if (gen !== removeGen) return; autoSave(root); }, 350));
      });
    });

    document.addEventListener('click', function (e) {
      var b = e.target && typeof e.target.closest === 'function' ? e.target.closest('[data-gp-act]') : null;
      var root = rootOf(b);
      if (!b || !root) return;
      e.preventDefault();
      var act = b.getAttribute('data-gp-act');
      if (act === 'open') {
        // WO-699 F4: opening writes nothing; the gift is saved by Save
        snaps.delete(root);
        setState(root, 'editing');
        focusFirst(root, b);
      } else if (act === 'edit') {
        snaps.set(root, values(root));
        setState(root, 'editing');
        focusFirst(root, b);
        store.put(root);
      } else if (act === 'save') {
        if (b.disabled) return;
        doSave(root, b);
      } else if (act === 'cancel') {
        var s = snaps.get(root);
        if (s) { restore(root, s); snaps.delete(root); setState(root, 'saved'); store.clear(); return; }
        var v = values(root);
        if (hasText(v)) { confirmBox(root, true); return; }
        setGift(root, false);
        setState(root, 'closed');
        store.clear();
      } else if (act === 'remove') {
        confirmBox(root, true);
      } else if (act === 'keep') {
        confirmBox(root, false);
      } else if (act === 'remove-yes') {
        removeGen++;   // WO-712 P1-E: any pending autosave timer, on any copy of the card, is now stale
        var tg = toggleOf(root);
        if (tg && tg.checked) setGift(root, false); else discard(root);
        store.clear();
        showError(false);
      }
    });

    // Adding the item to the cart while a gift's form is open counts as saving it (the fields save as they are typed), but WO-711 finding 21 / LAW 55: the card turns to saved ONLY after the cart
    // answer holds the same values; a failed check, or no persistence code at all, leaves the card open with the save error.
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.action || f.action.indexOf('/cart/add') === -1) return;
      document.querySelectorAll('[data-mz-gp][data-state="editing"]').forEach(function (root) {
        var t = toggleOf(root);
        if (!(t && t.checked)) return;
        var check = window.mezGift && window.mezGift.verify ? window.mezGift.verify(values(root)) : Promise.resolve(false);
        check.then(function (ok) {
          if (ok) { snaps.delete(root); setState(root, 'saved'); refresh(root); showError(false); } else { showError(true); }
        });
      });
    }, true);

    // WO-699 F9: a card that appears after the page has loaded is a redraw of the drawer: put back the open form and the words.
    function restoreCard(root) {
      if (root.__mzRestored) return;
      root.__mzRestored = true;
      if (document.readyState === 'loading') return;
      var s = store.get();
      if (!s || !s.open || root.getAttribute('data-state') === 'editing') return;
      [['[data-gift-to]', s.to], ['[data-gift-from]', s.from], ['[data-gift-note]', s.note]].forEach(function (pair) {
        var el = root.querySelector(pair[0]);
        if (!el || el.value === pair[1]) return;
        el.value = pair[1];
        el.dispatchEvent(new Event('input', { bubbles: true }));
      });
      // WO-719 GFT-10 (review): every radio gets an explicit state from the stored snapshot, so an occasion that was cleared while editing is not brought back by the saved one in the fresh markup
      var occFlipped = [];
      root.querySelectorAll('[data-gift-occasion]').forEach(function (r) {
        var want = Boolean(s.occ) && r.value === s.occ;
        if (r.checked !== want) { r.checked = want; occFlipped.push(r); }
      });
      if (occFlipped.length) occFlipped[0].dispatchEvent(new Event('change', { bubbles: true }));
      setState(root, 'editing');
      refresh(root);
    }
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            var cards = n.matches && n.matches('[data-mz-gp]') ? [n] : (n.querySelectorAll ? n.querySelectorAll('[data-mz-gp]') : []);
            Array.prototype.forEach.call(cards, restoreCard);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    document.querySelectorAll('[data-mz-gp]').forEach(function (r) { r.__mzRestored = true; });

    // A chosen occasion can be un-chosen by tapping it again.
    var was = null;
    document.addEventListener('pointerdown', function (e) {
      var label = e.target && typeof e.target.closest === 'function' ? e.target.closest('.mz-gp__occ label') : null;
      var input = label && label.querySelector('input');
      was = input && input.checked ? input : null;
    });
    document.addEventListener('click', function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('[data-gift-occasion]') || was !== input) return;
      was = null;
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();
